export const GOOGLE_AUTH_MESSAGE_TYPE = 'zimark:google-auth'

export type GoogleAuthMessage =
  | { type: typeof GOOGLE_AUTH_MESSAGE_TYPE; success: true; access_token: string }
  | { type: typeof GOOGLE_AUTH_MESSAGE_TYPE; success: false; error: string }
